import { Component } from "react";
import axios from "axios";

const ApiKey = "253irEHxUDJsm4hKJIPc06ogPRlsVIhp";

export class Gift extends Component {
state = {
  gifs: [],
  loading: false,
  page: 0,
  liked: {},
};

    toggleLike = (id) => {
  this.setState((prev) => ({
    liked: {
      ...prev.liked,
      [id]: !prev.liked[id],
    },
  }));
};
  componentDidMount() {
    this.fetchGifts();
  }
    
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.keyword != this.props.keyword) {
           this.setState({page:0} , ()  =>  this.fetchGifts())
        }
        
    }

  fetchGifts = async () => {
    this.setState({
      loading: true,
    });
      try {
        const offset = this.state.page * 15
      const res = await axios.get(`https://api.giphy.com/v1/gifs/search`, {
        params: {
          api_key: ApiKey,
          q: this.props.keyword,
              limit: 15,
          offset ,
        },
      });
      this.setState({
        gifs: res.data.data,
        loading: false,
      });
    } catch (e) {
      this.setState({
        loading: false,
      });
      console.log(e);
    }
  };
    
    nextPage = () => {
        this.setState((prev) => ({ page: prev.page + 1 }) , 
        this.fetchGifts)
    }

    prevPage = () => {
            if ( this.state.page === 0) return
        this.setState((prev) => ({ page: prev.page - 1 }) , 
        this.fetchGifts)
    }

  render() {
    return (
   <div className="gift">
  {this.state.loading ? (
    <p className="gift__loading">Loading...</p>
  ) : (
    <div className="gift__grid">
      {this.state.gifs.map((gif) => (
        <div className="gift__card" key={gif.id}>
          <img
            className="gift__image"
            src={gif.images.fixed_width.url}
            alt={gif.title}
          />
        </div>
      ))}
    </div>
  )}

  <div className="gift__pagination">
    <button onClick={this.prevPage}>←</button>
    <button onClick={this.nextPage}>→</button>
  </div>
</div>

    );
  }
}
